<template>
    <div class="p-5 w-full bg-white rounded-lg shadow">
        <h2 class="mb-4 text-lg font-semibold text-gray-800 flex gap-2 items-center">
            <slot name="icon" />
            {{ title }}
        </h2>
        <div class="flex w-full">
            <div class="flex" :class="chartClasses">
                <slot name="chart" />
            </div>
            <div class="flex-1" v-if="legendTitle">
                <div class="p-4">
                    <h3 class="mb-2 text-sm font-semibold text-gray-600">{{ legendTitle }}</h3>
                    <table class="space-y-3 w-full">
                        <tr v-for="(item, index) in series" :key="index">
                            <td role="row">
                                <div class="flex items-center">
                                    <div
                                        class="w-3 h-3 mr-2 rounded-full"
                                        :style="{ backgroundColor: item.color }"
                                    ></div>
                                    <span class="text-sm text-gray-600">{{ item.name }}</span>
                                </div>
                            </td>
                            <td class="text-sm font-medium text-gray-800" style="width: 5em">
                                <div class="flex justify-end">{{ item.value }}%</div>
                            </td>
                            <td class="text-sm font-medium text-gray-800" style="width: 5em">
                                <span class="flex justify-end">{{ item.count }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td role="row">
                                <div class="flex justify-end text-sm font-semibold text-gray-600">
                                    <span class="font-semibold">{{ $t('dashboard.total') }} :</span>
                                </div>
                            </td>
                            <td class="text-sm font-medium text-gray-800" style="width: 5em">
                                <div class="flex justify-end">
                                    <span v-if="mainTotal === 0">0%</span>
                                    <i
                                        v-else-if="mainTotal !== 100"
                                        :title="$t('dashboard.tooltipAlmost100')"
                                        class="flex gap-1 items-center"
                                    >
                                        100%
                                        <icon-information-outline width="16" height="16" />
                                    </i>
                                    <span v-else>100%</span>
                                </div>
                            </td>
                            <td class="text-sm font-medium text-gray-800" style="width: 5em">
                                <span class="flex justify-end">{{ mainCount }}</span>
                            </td>
                        </tr>
                    </table>
                    <div class="pt-4 mt-4 border-t border-gray-200">
                        <p class="text-sm text-gray-600">
                            <slot name="legendFooter" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IconInformationOutline from '@/icons/IconInformationOutline.vue';

export default {
    components: { IconInformationOutline },
    props: {
        title: { type: String, default: () => '' },
        legendTitle: { type: String, default: () => '' },
        series: { type: Array, default: () => [] },
        chartClasses: { type: String, default: 'h-40' },
    },
    computed: {
        mainTotal() {
            return this.series.reduce((acc, serie) => acc + serie.value, 0);
        },
        mainCount() {
            return this.series.reduce((acc, serie) => acc + serie.count, 0);
        },
    },
};
</script>
